const concatNombreSubClase = {}

function concat (subclase) {
  let subclaseStr;
    if (subclase === '') {
      subclaseStr = ''
    } else {
      subclaseStr = ` (${subclase})`
    }
  return subclaseStr
}

concatNombreSubClase.install = function (Vue) {
  Vue.filter('concNameSubC', (val) => {
    return concat(val)
  })
}



export default concatNombreSubClase



// WEBPACK FOOTER //
// ./src/filters/tiposDevice.js